<template>
  <div class="doc-upload">
    <div class="container">
      <div class="form">
        <section>
          <div class="doc-type">
            <el-label for="document-name">Nome do tipo:</el-label>
            <el-input
              type="text"
              id="document-name"
              v-model="documentType.name"
            />
            <div class="save">
              <el-button type="primary" @click="handleSave">Salvar</el-button>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- TABELA -->
    <el-table
      :data="tableData"
      :height="450"
      style="width: 100%"
      empty-text="Não há dados para serem listados"
      border
      v-loading="isLoading"
    >
      <el-table-column
        prop="name"
        label="Nome"
        align="center"
      ></el-table-column>
      <el-table-column label="Ação" width="150" align="center">
        <template v-slot="scope">
          <div class="actions">
            <font-awesome-icon :icon="iconEdit" @click="edit(scope.row)" />
            <font-awesome-icon :icon="iconCancel" @click="cancel(scope.row)" />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        v-if="getTotalPages > 1"
        layout="prev, pager, next"
        :total="getTotalContent"
        :current-page="getPage"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
/** Ícones */
// eslint-disable-next-line import/order
import { faBan, faPenToSquare } from '@fortawesome/free-solid-svg-icons'

/** Vuex */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useToast } from 'vue-toastification'
import { mapGetters, mapActions } from 'vuex'

// eslint-disable-next-line import/order
import iconVoucher from '@/assets/icons/icon-voucher.svg'

export default {
  name: 'DocumentTypeForm',

  components: {
    FontAwesomeIcon
  },
  setup() {
    const toast = useToast()

    return { toast }
  },

  data() {
    return {
      iconDoctor: iconVoucher,
      iconEdit: faPenToSquare,
      iconCancel: faBan,
      tableData: [],
      documentType: { name: '' },
      currentPage: 1,
      pageSize: 10
    }
  },

  mounted() {
    this.fetchDocumentsTypes()
  },

  computed: {
    ...mapGetters('documentType', [
      'getDocumentType',
      'getDocumentsTypes',
      'getLoadingDocument',
      'getTotalPages',
      'getTotalContent',
      'getPage'
    ]),
    ...mapGetters('documentManagement', [
      'getDocument',
      'getDocuments',
      'getLoadingDocument',
      'getTotalPages',
      'getTotalContent',
      'getPage'
    ]),

    isLoading() {
      return this.getLoadingDocument
    }
  },
  watch: {
    getPage: 'fetchDocumentsTypes',
    getDocumentsTypes: {
      handler(documentsTypes) {
        this.tableData = documentsTypes?.map((docType) => ({
          name: docType?.name,
          id: docType?.id
        }))
      },
      deep: true
    },
    docType() {
      this.getDocumentsTypes(this.docType)
    }
  },
  methods: {
    ...mapActions('documentType', [
      'fetchDocumentType',
      'fetchDocumentsTypes',
      'deleteDocumentType',
      'updatePage',
      'createDocumentType',
      'editDocumentType'
    ]),
    ...mapActions('documentManagement', ['fetchDocuments']),
    ...mapGetters('documentManagement', ['getDocuments']),

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    edit(row) {
      this.fetchDocumentType(row.id).then(() => {
        this.documentType = { ...this.getDocumentType }
        this.scrollToTop()
      })
    },
    async cancel(row) {
      this.deleteDocumentType(row.id)
    },
    handlePageChange(newPage) {
      this.updatePage(newPage)
    },
    handleSave() {
      if (this.documentType.id) {
        // Atualizando um tipo de documento existente
        this.editDocumentType(this.documentType).then(() => {
          this.documentType = { name: '' }
        })
      } else {
        // Criando um novo tipo de documento
        const body = { name: this.documentType.name }
        this.createDocumentType(body).then(() => {
          this.documentType = { name: '' }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.actions {
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 19px;
  margin: 2px;

  svg:hover {
    cursor: pointer;
    transform: translateY(-2px);
    transition: transform 0.2s ease;
  }
}

.input-group {
  padding: 10px 0;
}
</style>
